import request from "@/utils/requestSC";
import openRequest from "@/utils/request";

// 商品详情
export async function detail(params) {
  return request.post("/rest/goodsDetail/detail", params);
}

// 商品详情
export async function evaluationList(params) {
  return request.post("/rest/goodsDetail/evaluationList", params);
}

// 商品图片详情、规格参数、其他说明
export async function detailMore(params) {
  return request.post("/mob/goods/detailMore", params);
}

// 加载商品详情信息
export async function loadGoods(params) {
  return request.post("/rest/goodsDetail/loadGoods", params);
}

// 获取运费
export async function getFreightAmount(params) {
  return request.post("/rest/goodsDetail/freightAmount", params);
}

// 检查货品
export async function checkGoods(params) {
  return request.post("/mob/cart/checkGoods", params);
}

// 加入购物车
export async function addCart(params) {
  return request.get("/mob/cart/addCart", params);
}

// 校验
export async function buyskip(params) {
  return request.post("/mob/cart/buyskip", params);
}

// 根据货品ID获取用户BOID
export async function findBoIdByGoodsId(params) {
  return request.get("/mob/goods/findBoIdByGoodsId", params);
}

// 新增集采信息
export async function insertGoodsGroupPurchase(params) {
  return request.get("/mob/groupPurchase/insertGoodsGroupPurchase", params);
}

// 生成海报
export async function genBill(params) {
  return request.get("/mob/goods/genBill", params);
}

// 是否支持配送
export async function getIsAddrSupport(params) {
  return request.post("/mob/goods/getIsAddrSupport", params);
}

// 更新收货地址
export async function updateAddr(params) {
  return request.post("/mob/member/delivery/updateAddr", params);
}

// 新增收货地址
export async function addAddr(params) {
  return request.post("/mob/member/delivery/add", params);
}

// 获取收货地址
export async function alterDelivery(params) {
  return request.post("/mob/member/delivery/alterDelivery", params);
}

// 删除收货地址
export async function deleteAddr(params) {
  return request.post("/mob/member/delivery/delete", params);
}

// 自提地址
export async function shopDeliveryList(params) {
  return request.post("/mob/shopDelivery/shopDeliveryList", params);
}

// 领取店铺券
export async function getShopCoupon(params) {
  return request.post("/goods/coupon/getShopCoupon", params);
}

// 访问记录
export async function saveVisitRecord(params) {
  return request.post("/mob/goods/saveVisitRecord", params);
}

// 获取广告
export async function getAd(params) {
  return openRequest.get("nxin.advertisement.ad.list/1.0?id=202", params);
}

// 获取直播
export async function getLiveList(params) {
  return request({
    url: "/mob/recommend/getLiveList",
    method: "post",
    params
  });
}

// 商品详情
export async function getAddTaskGrantPoints(params) {
  return request.get("/rest/goods/addTaskGrantPoints", params);
}

// 根据规格查询商品skuId
export async function getGoodsSkuId(params) {
  return request.get("/goods/getSkuId.do", {
    params
  });
}
